<div>
  <p class="rps-paragraph-one rps-mark-bold">
    <a href="javascript:void(0)" class="risk-filter-link" role="button" tabindex="0" (click)="riskFilterDialog.openModalDialog();"
      aria-label="What is risk scale dialog title">Why should I care about risk?</a>
  </p>

  <div class="risk-container">
    <div>
      <div *ngFor="let filter of riskFilters">
        <input type="button" class="btn btn-light risk-button" [id]="'Risk' + filter"
          [ngClass]="{pressed: isRiskSelected(filter), riskValueOne: filter === '1', riskValueTwo: filter === '2', riskValueThree: filter === '3', riskValueFour: filter === '4', riskValueFive: filter === '5'}"
          [value]="filter" (click)="onRiskSelected($event)" [attr.title]="riskDesc[filter-1]"
           [attr.alt]="riskDesc[filter-1]" [attr.aria-pressed]="isRiskSelected(filter)"
          [attr.aria-labelledby]="'Risk'+filter+'label'" [attr.aria-describedby]="'Risk' + filter + 'description'">
        <p class="sr-only" [id]="'Risk'+filter+'label'">Risk Level {{filter}}</p>
        <p class="sr-only" [id]="'Risk'+filter+'description'">{{riskDesc[filter-1]}}</p>
      </div>


    </div>
    <div class="risk-less-more">
      <p class="rps-paragraph-two rps-grey">Less</p>
      <p class="rps-paragraph-two rps-grey">More</p>
    </div>
  </div>
</div>

<c11n-modal-dialog
    modalId="riskFilterDialog"
    headingText="Why should I care about risk?"
    #riskFilterDialog
>
  <div c11n-modal-dialog-body>
    <p class="rps-paragraph-one" id="whatisRiskScaleDialogDesc" [innerHtml]="formatLink(careAboutRisk?.contentValue)"
      attr.data-aem-source="{{careAboutRisk?.isAEM | json}}"></p>
  </div>
</c11n-modal-dialog>